import React, { useCallback, useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SearchIcon from "../../components/svgicons/searchicon";
import { ToastContainer } from "react-toastify";
import { Modal, ModalFooter, Offcanvas } from "reactstrap";
import LogoutLogo from "../../images/logout-logo.png";
import CircleBackArrow from "../../images/home/circle-back-arrow.svg";
import CartIcon from "../../images/home/cart-icon.svg";
// import CartIconGreen from "../../images/home/cart-icon-green.svg";
import BrandLogo from "../../images/kiko-logo-white.svg";
import ManageAddress from "../ManageAddress/component";
import {
  fetchCatelogues,
  updateCartItem,
  setSearchInputValue,
} from "../../slices/catalogSlice";
import { GET_PROFILE, UPDATE_PROFILE } from "../../api/apiList";
import CartHeader from "../../components/common/CartHeader";
import Login from "../Login/component";
import PreloginAddress from "../ManageAddress/preloginaddress";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../slices/userSlice";
import "./styles.scss";
import Order from "../Order/component";
import pin from "../../images/home/pin-icon.svg";
import DownWhiteIcon from "../../images/home/down-arrow-white.svg";
import ProfileImg from "../../images/home/user-icon.svg";
import YourAddress from "../YourAddress/component";
import API2 from "../../api/indexv2";
import { notify } from "../../components/common/utils";
import axios from "axios";
import searchIcon from "../../images/searchIcon.svg";
import CurrentLocationIcon from "../../images/home/current-location-icon.svg";
import store from "../../store";
import {
  getPlacesDetails,
  placeDetail,
  handleAddress,
} from "../../api/ApiService";
import {
  getLocations,
  saveSearchHistory,
  startLoadingMap,
} from "../../slices/mapSlice";
import debounce1 from "lodash/debounce";
import blacksearchIcon from "../../images/home/location-pin-green.svg";
import Loader from "../../components/common/loader";
import { fetchSellers } from "../../slices/sellerSlice";

let cancelToken;

const Header = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [YouraddressModal, setYourAddressModal] = useState(false);
  const [logout, setlogout] = useState(false);
  const [showPreLoginAddessModal, setShowPreLoginAddessModal] = useState(false);

  const [city, setCity] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const addressData = JSON.parse(localStorage.getItem("addressData"));

  const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
  const [searchmodal, setSearchModal] = useState(
    defaultAddress?.zipcode ? false : true
  );
  const [zipcode, setZipcode] = useState(
    defaultAddress?.zipcode ? defaultAddress.zipcode : ""
  );

  const isCheckoutPage = window.location.href.includes("buyer-checkout");
  const isSearchPage = window.location.href.includes("/mobile-search-result");
  const [orderHistory, setOrderhistory] = useState(false);
  const [yourAddress, setYouraddress] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [gender, setGender] = useState("");

  const [activeTab, setActiveTab] = useState("tabs-1"); // Initialize activeTab state
  const [tempAddress, setTempAddress] = useState({});
  const [getCurrentLocationLoader, setGetCurrentLocationLoader] =
    useState(false);
  const [loadingAddAddress, setLoadingAddAddress] = useState(false);

  const [openFromEdit, setOpenFromEdit] = useState(false);
  const token = useSelector((s) => s.user.token);
  const ondcSelectstatus = useSelector((s) => s.ondcPreorder.ondcSelectstatus);
  const searchInputValue = useSelector((s) => s.catalog.searchInputValue);
  const address = useSelector((s) => s.mapApi.address);
  const locations = useSelector((s) => s.mapApi.locations);
  const loadingMapAddress = useSelector((s) => s.mapApi.startLoadingMap);
  const selectAddressLoader = useSelector(
    (s) => s.mapApi.selectAddressMapLoading
  );
  const recentSearches = useSelector((s) => s.mapApi.searchHistory);

  const onChangePincodeDetail = (e) => {
    if (e.target.value !== "" && e.target.value.length >= 3) {
      handleAddress(e.target.value);
    } else {
      store.dispatch(startLoadingMap(false));
      store.dispatch(getLocations([]));
    }
  };

  useEffect(() => {
    console.log("Location Enable : ", address);

    // alert("Please allow location access in your browser for better experience.");
    if (address.latitude && address.pincode) {
      const defaultAddressT = {
        latitude: address?.latitude,
        longitude: address?.longitude,
        zipcode: address?.pincode,
        city: address?.city,
      };
      localStorage.setItem("defaultAddress", JSON.stringify(defaultAddressT));

      dispatch(
        fetchSellers({
          latitude: address?.latitude
            ? address?.latitude
            : defaultAddress?.latitude,
          longitude: address?.longitude
            ? address?.longitude
            : defaultAddress?.longitude,
          areaCode: address?.pincode
            ? address?.pincode
            : defaultAddress?.zipcode,
        })
      );
    }

    setGetCurrentLocationLoader(false);
    //  setSearchModal(false);
  }, [address]);

  const debouncedOnChange = debounce1(onChangePincodeDetail, 500);

  const SearchResult = (searches, save) => {
    const searchLocations = searches.map((item) => (
      <div
        className="select-location-result-item-kl"
        onClick={() => {
          setTempAddress({});
          placeDetail(item?.place_id);
          setGetCurrentLocationLoader(true);
          if (save) {
            store.dispatch(saveSearchHistory(item));
          }
          setSearchModal(false);
        }}
      >
        {getCurrentLocationLoader && <Loader />}

        <img src={blacksearchIcon} alt="Search Icon" />
        <div>
          <div className="select-location-pin-code-kl">
            {item?.structured_formatting?.main_text}
          </div>
          <div className="select-location-description-kl">
            {item?.description}
          </div>
        </div>
      </div>
    ));
    return <>{searchLocations}</>;
  };

  const userLogout = () => {
    dispatch(updateCartItem([]));
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("cart");
    localStorage.removeItem("sellerDetails");
    localStorage.removeItem("slug");
    if (defaultAddress?.address) {
      // delete defaultAddress?.address;
      const city = defaultAddress?.address?.city;
      defaultAddress.address = { city };
      localStorage.setItem("defaultAddress", JSON.stringify(defaultAddress));
    }
    dispatch(logoutUser());
    navigate("/");
    setlogout(false);
  };

  const handleGetCurrentLocation = () => {
    if (navigator.geolocation) {
      const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          // setTempAddress({
          //   ...tempAddress,
          //   latitude: latitude,
          //   longitude: longitude,
          // });
          const obj = { latitude, longitude };
          const defaultAddressT = {
            latitude: latitude,
            longitude: longitude,
            zipcode: defaultAddress?.zipcode || 0,
          };
          localStorage.setItem(
            "defaultAddress",
            JSON.stringify(defaultAddressT)
          );
          getPlacesDetails(obj);
          // setOpenFromEdit(false);
          // setMap(true);

          // setGetCurrentLocationLoader(false);
        },
        (error) => {
          // setGetCurrentLocationLoader(false);
          if (error.code === error.PERMISSION_DENIED) {
            notify(
              "error",
              "Allow location access in your browser to continue"
            );
          } else {
            notify(
              "error",
              "Error in facting your current location Try Again!"
            );
          }
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  const updateProfile = async () => {
    if (!name || !email || !gender) {
      notify("error", "Please fill all the fields");
      return;
    }
    try {
      const body = {
        userId: user?.userId,
        name,
        email,
        gender,
      };
      const response = await API2.post(UPDATE_PROFILE, body);
      if (response.data) {
        notify("success", "Updated Successfully");
      }
    } catch (error) {
      console.error("Error fetching seller data:", error);
    }
  };

  const getProfile = async () => {
    try {
      const body = {
        userId: user.userId,
      };
      const response = await API2.post(GET_PROFILE, body);
      if (response.data) {
        const user = response.data.user;
        setName(user.name || "");
        setEmail(user.email || "");
        setGender(user.gender || "");
      }
    } catch (error) {
      console.error("Error fetching seller data:", error);
    }
  };

  const dropdownRef = useRef(null);
  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isDropdownOpen]);

  const handleLoginClick = () => {
    if (!token) {
      setModalIsOpen(true);
    } else {
      setIsDropdownOpen(false);
    }
  };
  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };
  const closeCart = () => {
    setIsCartOpen(false);
  };

  useEffect(() => {
    const getZipcodeFromAddress = () => {
      if (defaultAddress) {
        setZipcode(defaultAddress.zipcode);
        setCity(defaultAddress.address?.city);
      }
    };
    const addressData = JSON.parse(localStorage.getItem("addressData"));
    if (addressData && addressData?.zipcode) {
      setZipcode(addressData?.zipcode);
      setCity(addressData?.address.city);
    } else {
      getZipcodeFromAddress();
    }
  }, [addressData?.zipcode, defaultAddress]);

  useEffect(() => {
    if (props?.isQuickCommerce) {
    } else if (!defaultAddress && !token) {
      // setShowPreLoginAddessModal(true);
    }
  }, [defaultAddress, token]);

  useEffect(() => {
    if (location.pathname !== "/mobile-search-result") {
      dispatch(setSearchInputValue(""));
    }
  }, [location.pathname, dispatch]);

  const user = JSON.parse(localStorage.getItem("user"));

  const getSellerDetails = () => {
    try {
      return JSON.parse(localStorage.getItem("sellerDetails") || "");
    } catch (error) {
      return null;
    }
  };

  const sellerDetails = getSellerDetails();
  const [catalogueData, setCatalogData] = useState([]);

  let cartItems = JSON.parse(localStorage.getItem("cart"));
  let totalAmount = 0;
  if (cartItems) {
    cartItems.forEach((item) => {
      totalAmount += item?.quantity * item?.catalogData.price;
    });
  }
  let cartItemsLength = cartItems?.length || 0;
  const defaultLat = parseFloat(defaultAddress?.latitude);
  const defaultLon = parseFloat(defaultAddress?.longitude);
  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };

  const callSearchApi = async (e = "") => {
    if (typeof cancelToken != typeof undefined) {
      cancelToken.cancel("Operation canceled due to new request.");
    }
    // save the cancel token for the current request
    cancelToken = axios.CancelToken.source();
    const location = `${defaultLat},${defaultLon}`;
    dispatch(
      fetchCatelogues({
        search: e.target?.value,
        location: location,
        areaCode: defaultAddress.zipcode,
        token: cancelToken.token,
      })
    );
  };
  const optimizedUserFn = useCallback(debounce(callSearchApi), []);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedText = e.clipboardData?.getData("text");
    if (!pastedText) return;
    const convertedValue = pastedText
      .split(/\r?\n|\u2028|\u2029/g)
      .map((item) => item.trim())
      .filter(Boolean)
      .join(", ")
      .replace(/\s*,\s*/g, ", ");
    dispatch(setSearchInputValue(convertedValue));
    optimizedUserFn({ target: { value: convertedValue } });
  };

  return (
    <>
      {props?.fromQuickCommerce ? (
        <PreloginAddress
          setPincode={props?.setPincode}
          showPreLoginAddessModal={props?.isApiNotCalled}
          setShowPreLoginAddessModal={setShowPreLoginAddessModal}
        ></PreloginAddress>
      ) : (
        <>
          <header className="header-section-kl">
            <ToastContainer
              autoClose={300}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="right"
              position="top-right"
            />
            <Modal
              isOpen={searchmodal}
              toggle={() => {
                setSearchModal(false);
              }}
              aria-labelledby="contained-modal-title-v"
              ed
              style={{ maxWidth: "600px" }}
              centered
              className="custom-modal-kl"
            >
              <div className="custom-modal-header-kl">
                <div className="custom-modal-title-kl">Select Location</div>
              </div>
              <div className="custom-modal-body-kl select-location-modal-kl">
                <div className="select-location-search-kl">
                  <img
                    src={searchIcon}
                    alt="Search1 Icon"
                    className="select-location-search-icon-kl"
                  />
                  <input
                    className="form-control"
                    type="search"
                    placeholder="Search for an area , Location name, Pincode"
                    onChange={debouncedOnChange}
                  />
                </div>
                {/* {loadingMapAddress && !selectAddressLoader && <Loader />} */}
                <div className="select-location-list-kl">
                  <div className="select-location-items">
                    <img
                      src={CurrentLocationIcon}
                      alt="Location Icon"
                      className="location-icon-kl"
                    />

                    <button
                      type="button"
                      className="current-location-btn-kl"
                      onClick={() => {
                        handleGetCurrentLocation();
                        setSearchModal(false);
                      }}
                    >
                      Use My Current Location{" "}
                    </button>
                  </div>
                  {/* <div className="select-location-items">
              <img src={LocationPinIcon} alt="Location Icon" className="location-icon-kl" />
              {getCurrentLocationLoader ? (
                <Loader />
              ) : (
                <button type="button"
                  className="current-location-btn-kl"
                  onClick={() => {
                    handleGetCurrentLocation();
                  }}
                >
                  Locate On Map{" "}
                </button>
              )}
            </div> */}
                </div>
                <div className="select-location-container-kl">
                  <ul className="nav nav-tabs" role="tablist">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "tabs-1" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("tabs-1")}
                      >
                        {locations.length > 0
                          ? "Choose Delivery Location"
                          : "Recent Search"}
                      </button>
                    </li>
                  </ul>
                  <div className="tab-content">
                    <div
                      className={`tab-pane ${
                        activeTab === "tabs-1" ? "active show" : ""
                      }`}
                    >
                      <div className={"select-location-result-list-kl"}>
                        {locations.length > 0
                          ? SearchResult(locations, true)
                          : recentSearches?.length > 0
                          ? SearchResult(recentSearches, false)
                          : "Your recent searches will appear here."}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
            <div className="header-container-kl">
              <div className="header-left-kl">
                <div className="logo-address-flex">
                  {location.pathname !== "/" && (
                    <button
                      className="header-back-arrow-kl"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      <img
                        src={CircleBackArrow}
                        alt="Logo"
                        className="back-icon-kl"
                      />
                    </button>
                  )}
                  <a
                    href="/"
                    className={`brand-logo ${
                      location.pathname !== "/" ? "hide-on-mobile" : ""
                    }`}
                  >
                    <img src={BrandLogo} alt="Logo" className="logo-icon" />
                  </a>
                </div>
                {!isSearchPage && (
                  <>
                    <div
                      className="buyer-pin-code-kl"
                      onClick={() => {
                        const userId = JSON.parse(localStorage.getItem("user"));
                        if (!token) {
                          // handleGetCurrentLocation();
                          // setShowPreLoginAddessModal(true);
                          setSearchModal(true);
                        } else if (userId) {
                          setYourAddressModal(true);
                        } else {
                          userLogout();
                          notify(
                            "error",
                            "Session expired. Please log in first!"
                          );
                        }
                      }}
                    >
                      <img
                        src={pin}
                        alt="location"
                        className="buyer-pin-code-icon-kl"
                      />
                      {zipcode && zipcode.length !== 0 && (
                        <div className="buyer-pin-number-kl">
                          {`${
                            defaultAddress?.city
                              ? defaultAddress?.city + " -"
                              : defaultAddress?.address?.city
                              ? defaultAddress?.address?.city + " -"
                              : ""
                          }`}{" "}
                          {zipcode}
                        </div>
                      )}
                      <img
                        src={DownWhiteIcon}
                        alt="location"
                        className="buyer-pin-code-icon-kl"
                      />
                    </div>
                  </>
                )}
                {(location.pathname === "/qc" ||
                  location.pathname === "/quickcommerce") && (
                  <button
                    onClick={() => {
                      navigate("/", { state: { scrollTo: "nearBySection" } });
                    }}
                    className="view-all-stores-btn"
                  >
                    View All Stores
                  </button>
                )}
              </div>
              <div
                className={`header-search-kl ${
                  location.pathname === "/seller" ||
                  location.pathname === "/qc" ||
                  location.pathname === "/quickcommerce" ||
                  props?.hide
                    ? "hide-on-mobile"
                    : ""
                }`}
              >
                <div
                  className={`header-search-inner-kl ${
                    location.pathname === "/seller" ||
                    location.pathname === "/qc" ||
                    location.pathname === "/quickcommerce" ||
                    props?.hide
                      ? "hide-on-mobile"
                      : ""
                  }`}
                >
                  <input
                    className="d-inline-block text-truncate"
                    type="text"
                    value={searchInputValue}
                    autoFocus={
                      window.location.pathname === "/mobile-search-result"
                    }
                    placeholder="Paste your grocery list here"
                    onPaste={handlePaste}
                    onChange={(e) => {
                      dispatch(setSearchInputValue(e.target.value));
                      optimizedUserFn(e);
                    }}
                    onClick={(e) => {
                      e.preventDefault();
                      if (
                        window.location.pathname !== "/mobile-search-result"
                      ) {
                        navigate("/mobile-search-result");
                      }
                    }}
                  />
                  <button
                    className="header-search-btn-kl"
                    type="button"
                    onClick={() =>
                      callSearchApi({
                        target: { value: searchInputValue },
                      })
                    }
                  >
                    <SearchIcon alt="Search Icon" />
                  </button>
                </div>
                {catalogueData && catalogueData?.length > 0 ? (
                  <div className="searchDropdown">
                    {catalogueData?.map((data) => {
                      return (
                        <p
                          onClick={() => {
                            const encodedPId = encodeURIComponent(
                              data?.providerId
                            );
                            const encodedPCode = encodeURIComponent(data?._id);
                            !props.func &&
                              navigate(
                                `/product-details?providerId=${encodedPId}&productCode=${encodedPCode}`,
                                {
                                  state: {
                                    catalogDataArray: {},
                                  },
                                }
                              );
                            props.func && props.func(data);
                            props.func && setCatalogData([]);
                          }}
                        >
                          {data.productName}
                        </p>
                      );
                    })}
                  </div>
                ) : null}
              </div>
              {(props?.hide ||
                location.pathname === "/seller" ||
                location.pathname === "/qc" ||
                location.pathname === "/quickcommerce") && (
                <div className="title-on-scroll d-inline-block- text-truncate- truncate-2-lines">
                  {props?.title ?? ""}
                </div>
              )}
              <div className="header-right-kl">
                <div
                  className="account-dropdown-kl  account-dropdown-show-kl"
                  ref={dropdownRef}
                  onMouseDown={(e) => e.stopPropagation()}
                >
                  <button
                    className={
                      token
                        ? "btn login-btn-container-kl"
                        : "btn login-btn-container-kl"
                    }
                    type="button"
                    onClick={() => {
                      if (token) {
                        toggleDropdown();
                      } else {
                        handleLoginClick();
                      }
                    }}
                  >
                    {token ? (
                      <div className="profile-flex-kl">
                        <div className="profile-circle-kl">
                          <img src={ProfileImg} alt="ProfileImage" />
                        </div>
                        <div className="profile-name-kl">
                          My Account
                          <img src={DownWhiteIcon} alt="icon" />
                        </div>
                      </div>
                    ) : (
                      <div className="login-btn-kl">Login</div>
                    )}
                  </button>
                  {isDropdownOpen && (
                    <ul className="account-menu-kl">
                      <li
                        className="account-dropdown__account-info-kl"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasAccount"
                        aria-controls="offcanvasRightAccount"
                        onClick={() => {
                          getProfile();
                        }}
                      >
                        <div className="account-info--heading">My Account</div>
                        <div className="account-number">{user?.phone}</div>
                      </li>
                      <li>
                        <div
                          className="menu-logout-list-kl"
                          type="button"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasAddress"
                          aria-controls="offcanvasRightaddress"
                          onClick={() => {
                            setYouraddress(true);
                          }}
                        >
                          Your Addresses
                        </div>
                        <div
                          className="menu-logout-list-kl"
                          type="button"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvasOrder"
                          aria-controls="offcanvasRightOrder"
                          onClick={() => {
                            setIsDropdownOpen(false);
                            setOrderhistory(true);
                            setIsDropdownOpen(false);
                          }}
                        >
                          Order History
                        </div>
                        <div
                          type="button"
                          data-bs-dismiss="offcanvas"
                          className="menu-logout-list-kl"
                          onClick={() => {
                            setlogout(true);
                            setIsDropdownOpen(false);
                          }}
                        >
                          Logout
                        </div>
                      </li>
                    </ul>
                  )}
                </div>
                {!isCheckoutPage && (
                  <>
                    <horizontalLine className="horizontal-line" />
                    <button
                      className="buyer-cart-kl"
                      type="button"
                      onClick={() => {
                        toggleCart();
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        <img src={CartIcon} alt="" />
                      </div>
                      <div className="add-items-container-kl">
                        {cartItemsLength && cartItemsLength > 0 ? (
                          <div className="add-items-kl">{`${cartItemsLength} ${
                            cartItemsLength > 1 ? "Items" : "Item"
                          }`}</div>
                        ) : (
                          <></>
                        )}
                        {cartItemsLength && cartItemsLength > 0
                          ? `₹${totalAmount?.toFixed(2)}`
                          : "My Cart"}
                      </div>
                    </button>
                    {/* <button
                      className="buyer-cart-kl buyer-cart-mobile-kl"
                      type="button"
                      onClick={() => {
                        toggleCart();
                      }}
                    >
                      <div style={{ position: "relative" }}>
                        <img className="cart-icon-mobile-kl" src={CartIconGreen} alt="" />
                        {cartItemsLength && cartItemsLength > 0 ? (
                          <div className="cartCounter-kl">
                            {cartItemsLength}
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </button> */}
                  </>
                )}
              </div>
            </div>
            <Modal
              isOpen={YouraddressModal}
              size="lg"
              toggle={() => setYourAddressModal(false)}
              className="custom-modal-kl"
            >
              <YourAddress
                setZipcode={setZipcode}
                setYourAddressModal={setYourAddressModal}
              />
            </Modal>
            {modalIsOpen && (
              <Login
                isOpenFromCart={false}
                modalIsOpen={modalIsOpen}
                setModalIsOpen={setModalIsOpen}
              ></Login>
            )}
            {showPreLoginAddessModal && (
              <PreloginAddress
                {...props}
                showPreLoginAddessModal={showPreLoginAddessModal}
                setShowPreLoginAddessModal={setShowPreLoginAddessModal}
              ></PreloginAddress>
            )}
          </header>
          <Modal
            isOpen={logout}
            aria-labelledby="contained-modal-title-vcenter"
            toggle={() => {
              setlogout(false);
            }}
            centered
            className="clearcartmodal custom-modal-kl thank-you-for-visiting"
          >
            <div className="custom-modal-body-kl">
              <div className="confirmLogout">
                <img src={LogoutLogo} alt="Logout" />
                <h1 className="confirm-subtitle">
                  Thank you for visiting {sellerDetails?.storeName}
                </h1>
              </div>
              <ModalFooter className="border-0 flex-column">
                <h5 className="confirmtitle">
                  Are you sure you want to logout?
                </h5>
                <div className="d-flex justify-content-center gap-2">
                  <button
                    type="button"
                    onClick={() => {
                      setlogout(false);
                    }}
                    className="btn btn-outline"
                  >
                    No
                  </button>
                  <button
                    type="button"
                    onClick={() => {
                      userLogout();
                    }}
                    className="btn btn-primary"
                  >
                    Yes
                  </button>
                </div>
              </ModalFooter>
            </div>
          </Modal>
          <Offcanvas
            isOpen={isCartOpen}
            toggle={closeCart}
            direction="end"
            backdrop={ondcSelectstatus === "loading" ? "static" : true}
            className="offcanvas offcanvas-end sidebaroffcanvas custom-drawer-kl my-cart-drawer-kl"
          >
            <CartHeader isCartOpen={isCartOpen} closeCart={closeCart} />
          </Offcanvas>

          <div
            className="offcanvas offcanvas-end custom-drawer-kl personal-details-drawer-kl"
            tabIndex="-1"
            id="offcanvasAccount"
            aria-labelledby="offcanvasRightLabelAccount"
          >
            <div className="drawer-header-kl">
              <div className="drawer-header-title-kl">Profile</div>
              <button
                type="button"
                className="btn-close drawer-header-close-btn-kl"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                onClick={closeCart}
              ></button>
            </div>
            <div className="drawer-body-kl">
              <div className="personal-details-drawer-title-kl">
                Personal Details
              </div>
              <form className="personal-details-drawer-form-kl">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Your Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  type="text"
                  className="form-control"
                  placeholder="Mobile Number"
                  value={user?.phone}
                  disabled
                />
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </form>
              <div>
                <div className="personal-details-drawer-title-kl">Gender</div>
                <div className="gender-list-kl">
                  <div className="gender-item-kl">
                    <input
                      type="radio"
                      id="Male"
                      name="gender"
                      value="Male"
                      checked={gender === "Male"}
                      onChange={(e) => setGender(e.target.value)}
                    />
                    <label htmlFor="Male" className="label-kl">
                      Male
                    </label>
                  </div>
                  <div className="gender-item-kl">
                    <input
                      type="radio"
                      id="Female"
                      name="gender"
                      value="Female"
                      checked={gender === "Female"}
                      onChange={(e) => setGender(e.target.value)}
                    />
                    <label htmlFor="Female" className="label-kl">
                      Female
                    </label>
                  </div>
                </div>

                <button
                  className="upload-profile-btn-kl"
                  type="button"
                  onClick={updateProfile}
                >
                  Update Profile
                </button>
              </div>
            </div>
          </div>
          <div
            className="offcanvas offcanvas-end orderSidebar custom-drawer-kl  order-drawer-kl "
            tabIndex="-1"
            id="offcanvasOrder"
            aria-labelledby="offcanvasRightLabelOrder"
          >
            <div className="drawer-header-kl">
              <div className="drawer-header-title-kl">Orders</div>
              <button
                type="button"
                className="btn-close drawer-header-close-btn-kl"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="drawer-body-kl p-0">
              {orderHistory && token && <Order />}
            </div>
          </div>
          <div
            className="offcanvas offcanvas-end custom-drawer-kl your-addresses-drawer-kl"
            id="offcanvasAddress"
            aria-labelledby="offcanvasRightLabelAddress"
          >
            <div className="offcanvas-body p-0">
              {yourAddress && token && (
                <ManageAddress
                  setZipcode={setZipcode}
                  setAddressModal={setYourAddressModal}
                  isInHeader={true}
                />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};
export default Header;
